import type { PropsWithChildren, ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

interface IStateContainerProps {
    title: ReactNode;
    subtitle: ReactNode;
}

export const StateContainer = ({ children, title, subtitle }: PropsWithChildren<IStateContainerProps>) => (
    <Stack
        gap="16px"
        flexGrow={1}
        justifyContent="center"
        alignItems="center"
    >
        {children}
        <Stack
            gap="8px"
            alignItems="center"
        >
            <Text
                fontVariant="h5"
                color={colorsPalettes.carbon[500]}
            >
                {title}
            </Text>
            <Text
                fontVariant="body1"
                color={colorsPalettes.carbon[300]}
            >
                {subtitle}
            </Text>
        </Stack>
    </Stack>
);
